import { jsx as _jsx } from "react/jsx-runtime";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { forwardRef } from 'react';
import { cn } from "../lib/cn.js";
/**
 * Seções de formulário — "Geral / Comercial / Fiscal", como
 * `docs/UI_UX.md` pede para um formulário grande.
 *
 * `apps/web/src/routes/financeiro.tsx:234-258` já tinha o visual certo — um
 * par de botões dentro de uma trilha — montado à mão com `role="tablist"` e
 * `role="tab"` mas sem `aria-controls`, sem `id` ligando aba a painel, e sem
 * as setas movendo o foco entre abas (o comportamento que o ARIA Authoring
 * Practices exige para este padrão). `@radix-ui/react-tabs` entrega as três
 * coisas de graça; aqui só o visual é novo — o mesmo par de botões numa
 * trilha, agora com o ARIA completo por baixo.
 */
export const Tabs = TabsPrimitive.Root;
export const TabsList = forwardRef(({ className, ...props }, ref) => (_jsx(TabsPrimitive.List, { ref: ref, className: cn(
    /*
     * `max-w-full overflow-x-auto` (F248): as sete abas do Editar produto
     * não cabiam numa janela estreita do Modo PC e empurravam o formulário
     * inteiro para o lado. Agora a fileira de abas rola sozinha.
     */
    'inline-flex max-w-full gap-1 overflow-x-auto rounded-(--radius-md) border border-(--border-subtle) p-1', className), ...props })));
TabsList.displayName = 'TabsList';
export const TabsTrigger = forwardRef(({ className, ...props }, ref) => (_jsx(TabsPrimitive.Trigger, { ref: ref, className: cn('shrink-0 whitespace-nowrap rounded-(--radius-sm) px-3 py-1.5 text-(length:--text-sm) text-(--text-secondary)', 'transition-colors duration-(--duration-fast)', 'hover:text-(--text-primary)', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--brand-primary)', 'data-[state=active]:bg-(--brand-primary) data-[state=active]:text-(--text-on-brand)', 'disabled:cursor-not-allowed disabled:opacity-50', className), ...props })));
TabsTrigger.displayName = 'TabsTrigger';
export const TabsContent = forwardRef(({ className, ...props }, ref) => (_jsx(TabsPrimitive.Content, { ref: ref, className: cn('focus-visible:outline-none', 
    // Radix já não monta o painel inativo — sem `hidden` para duplicar.
    className), ...props })));
TabsContent.displayName = 'TabsContent';
//# sourceMappingURL=tabs.js.map